/**
 * Created by Rumyantsev Daniil on 20.06.2018.
 */

import { Pipe, PipeTransform } from '@angular/core';
/**
 * Меняет дату из UTC в дату в текущей таймзоне
 *
 * Usage:
 *   dateInMillis | utcToLocal
 */
@Pipe({name: 'utcToLocal'})
export class UtcToLocalTimezonePipe implements PipeTransform {

  transform(dateToOffset: Date): any {
    let date = new Date();
    const userTimezoneOffset = date.getTimezoneOffset() * 60 * 1000;
    return new Date(dateToOffset.getTime() - userTimezoneOffset);
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/utc-to-local-timezone.pipe.ts